<script setup>
import { ref, provide, computed, readonly, onMounted } from 'vue'
import { useAlert } from './useAlert.js'
import AlertToast from './AlertToast.vue'
import ConfirmDialog from './ConfirmDialog.vue'
import { AlertContext } from './AlertContext.js'

/*
import { registerAlert } from '@/utils/alert/alertBridge'

onMounted(() => {
  registerAlert(alert)
})
*/

// Toast Alerts
const alerts = ref([])
// Disable auto-dismiss by setting defaultTimeout to 0
const { push, remove, success, error, info, warning } = useAlert(alerts, { defaultTimeout: 0 })

// Confirm Modal
const isConfirmOpen = ref(false)
const confirmTitle = ref('')
const confirmContent = ref(null)
const confirmConfirmText = ref('')
const confirmCancelText = ref('취소')
const confirmTeleportTo = ref('body')
let confirmResolver = null
const confirmVariant = ref('primary')
const confirmBeforeConfirm = ref(null)
const confirmPreventOutsideClose = ref(false)

const confirm = (options) => {
  isConfirmOpen.value = true
  confirmTitle.value = options.title
  confirmContent.value = options.content
  confirmConfirmText.value = options.confirmText || '확인'
  confirmCancelText.value = options.cancelText ?? '취소'
  confirmTeleportTo.value = options.teleportTo || 'body'
  confirmVariant.value = options.variant || 'primary'
  confirmBeforeConfirm.value = options.beforeConfirm || null
  confirmPreventOutsideClose.value = options.preventOutsideClose || false

  return new Promise((resolve) => {
    confirmResolver = resolve
  })
}

const handleConfirm = () => {
  if (confirmResolver) {
    confirmResolver(true)
  }
  isConfirmOpen.value = false
}

const handleCancel = () => {
  if (confirmResolver) {
    confirmResolver(false)
  }
  isConfirmOpen.value = false
}

const isBusy = computed(() => alerts.value.length > 0 || isConfirmOpen.value)

provide(AlertContext, { push, remove, success, error, info, warning, confirm, isBusy: readonly(isBusy) })
</script>

<template>
  <slot :is-busy="isBusy" />

  <!-- Toast Container -->
  <AlertToast
    v-for="alert in alerts"
    :key="alert.id"
    :model-value="true"
    :title="alert.title"
    :content="alert.message"
    :variant="alert.variant"
    @update:model-value="() => remove(alert.id)"
  />
  <!-- Confirm Modal -->
  <ConfirmDialog
    v-if="isConfirmOpen"
    :model-value="isConfirmOpen"
    :title="confirmTitle"
    :content="confirmContent"
    :confirm-text="confirmConfirmText"
    :cancel-text="confirmCancelText"
    :teleport-to="confirmTeleportTo"
    :confirm-variant="confirmVariant"
    :before-confirm="confirmBeforeConfirm"
    :prevent-outside-close="confirmPreventOutsideClose"
    @confirm="handleConfirm"
    @cancel="handleCancel"
    @update:model-value="handleCancel"
  />
</template>
<style scoped></style>












